<div class="min-h-screen bg-gray-50/50 p-6 md:p-12 md:pt-8 font-sans">
    
    <!-- Header Section -->
    <div class="max-w-7xl mx-auto mb-8">
        <a routerLink="/admin-dashboard" class="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-gray-800 transition mb-4 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
            Back to Dashboard
        </a>

        <div class="flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
            <div>
                <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight">New Category Launches</h1>
                <p class="text-gray-500 mt-2">Full report of newly added inventory and assembly line status.</p>
            </div>

            <!-- Stats Cards -->
            <div class="flex gap-4 overflow-x-auto pb-2 md:pb-0 w-full md:w-auto">
                <div *ngFor="let stat of stats" class="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-3 min-w-[160px]">
                    <div [class]="'w-10 h-10 rounded-full flex items-center justify-center text-xl ' + stat.color">
                        {{ stat.icon }}
                    </div>
                    <div>
                        <p class="text-xs text-gray-500 font-bold uppercase">{{ stat.label }}</p>
                        <p class="text-lg font-bold text-gray-900">{{ stat.value }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Filter Tabs -->
    <div class="max-w-7xl mx-auto mb-6">
        <div class="inline-flex bg-white p-1 rounded-xl shadow-sm border border-gray-100">
            <button (click)="setTab('all')" 
                [class.bg-gray-900]="activeTab === 'all'" [class.text-white]="activeTab === 'all'"
                [class.text-gray-500]="activeTab !== 'all'"
                class="px-6 py-2 rounded-lg text-sm font-bold transition-all">All</button>
            
            <button (click)="setTab('ready')" 
                [class.bg-purple-600]="activeTab === 'ready'" [class.text-white]="activeTab === 'ready'"
                [class.text-gray-500]="activeTab !== 'ready'"
                class="px-6 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2">
                💎 Ready Products
            </button>
            
            <button (click)="setTab('assembly')" 
                [class.bg-blue-600]="activeTab === 'assembly'" [class.text-white]="activeTab === 'assembly'"
                [class.text-gray-500]="activeTab !== 'assembly'"
                class="px-6 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2">
                ⚒️ Assembly Line
            </button>
        </div>
    </div>

    <!-- MAIN GRID CONTENT -->
    <div class="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">

        <!-- LEFT SIDE: Ready Products Table -->
        <div *ngIf="showReady" class="flex flex-col gap-3">
            <h3 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                <span class="w-1.5 h-6 bg-purple-500 rounded-full"></span> Ready Products
                <span class="text-xs bg-purple-50 text-purple-700 border border-purple-100 px-2 py-0.5 rounded-full font-bold">{{ readyProducts.length }} Items</span>
            </h3>

            <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <div class="overflow-x-auto">
                    <table class="w-full text-left border-collapse">
                        <thead>
                            <tr class="bg-gray-50 border-b border-gray-100 text-[11px] uppercase tracking-wider text-gray-500 font-bold">
                                <th class="px-5 py-4">Product Name</th>
                                <!-- <th class="px-5 py-4">Category</th> -->
                                <th class="px-5 py-4">Added</th>
                                <th class="px-5 py-4 text-right">Value</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-50">
                            <!-- Rows with more spacing (py-4) -->
                            <tr *ngFor="let item of readyProducts" class="group hover:bg-purple-50/40 transition-colors duration-150 cursor-pointer">
                                
                                <td class="px-5 py-4">
                                    <div class="flex items-center gap-3">
                                        <div class="w-8 h-8 bg-purple-50 text-purple-600 rounded flex items-center justify-center text-sm shadow-sm border border-purple-100">
                                            {{ item.icon }}
                                        </div>
                                        <span class="text-xs font-bold text-gray-800 group-hover:text-purple-700 whitespace-nowrap">{{ item.name }}</span>
                                    </div>
                                </td>

                                <!-- <td class="px-5 py-4">
                                    <span class="text-[10px] font-semibold text-gray-500 bg-gray-100 px-2 py-1 rounded-full border border-gray-200">
                                        {{ item.category }}
                                    </span>
                                </td> -->

                                <td class="px-5 py-4">
                                    <span class="text-[11px] text-gray-400 font-medium whitespace-nowrap">
                                      {{ item.created_at }}
                                    </span>
                                </td>

                                <td class="px-5 py-4 text-right">
                                    <span class="text-xs font-bold text-gray-800 font-mono">₹ {{ item.mrp }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- RIGHT SIDE: Assembly Line Table -->
        <div *ngIf="showAssembly" class="flex flex-col gap-3">
            <h3 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                <span class="w-1.5 h-6 bg-blue-500 rounded-full"></span> Assembly Line Status
                <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-2 py-0.5 rounded-full font-bold">{{ assemblyLine.length }} Processes</span>
            </h3>

            <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table class="w-full text-left">
                    <thead class="bg-gray-50 border-b border-gray-100">
                        <tr>
                            <th class="px-5 py-4 text-[11px] font-bold text-gray-500 uppercase">Product Name</th>
                            <th class="px-5 py-4 text-[11px] font-bold text-gray-500 uppercase text-center">Added</th>
                            <th class="px-5 py-4 text-[11px] font-bold text-gray-500 uppercase text-right">Value</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <!-- Rows with more spacing (py-4) -->
                        <tr *ngFor="let item of assemblyLine" class="hover:bg-blue-50/30 transition-colors">
                            <td class="px-5 py-4">
                                <div class="flex items-center gap-3">
                                    <span class="text-lg">{{ item.icon }}</span>
                                    <div>
                                        <p class="font-bold text-gray-800 text-xs">{{ item.name }}</p>
                                        <p class="text-[9px] text-gray-400 uppercase tracking-wide leading-tight">{{ item.process }}</p>
                                    </div>
                                </div>
                            </td>
                            <td class="px-5 py-4 text-center">
                                <span class="font-mono font-bold text-gray-700 bg-gray-100 px-2 py-1 rounded text-[10px]">
                                  {{ item.created_at }}
                                </span>
                            </td>
                            <td class="px-5 py-4 text-right">
                                <span [class]="'text-[10px] font-bold px-2 py-1 rounded inline-block ' + item.color">
                                   ₹ {{ item.mrp }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div>